import React from 'react';
import { Grid, Typography } from "@mui/material"

const FieldsDetails = ({ taskData, customFieldValues }) => {
  let formattedActualDate = ''


  //placeholder to have the grids keep their size while data is loading
  if (!taskData || !taskData.custom_fields) {
    return (
      <Grid 
        container 
        rowSpacing={1} 
        columnSpacing={{ xs: 1, sm: 2, md: 3 }} 
        style={{ width: "100%" }}
      >
        {[...Array(4)].map((_, index) => (
          <Grid 
            item 
            xs={6} 
            key={index} 
            style={{ minWidth: "500px" }}
          >
            <Typography
              variant="body2"
              style={{
                minHeight: "20px",
                background: "#f0f0f0",
                borderRadius: "5px",
                padding: "10px",
                width: "100%",
                display: "block",
              }}
            >
              Loading...
            </Typography>
          </Grid>
        ))}
      </Grid>
    );
  }
      const sortedFields = taskData.custom_fields.sort((a, b) => {
        const aIndex = Object.keys(customFieldValues).indexOf(a.id);
        const bIndex = Object.keys(customFieldValues).indexOf(b.id);
        return aIndex - bIndex;
      });

    //return main grid area
    return (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {sortedFields.map((field) => {
            const label = customFieldValues[field.id]; 
            if (!label) return null; 
    
            let formattedValue = field.value;
            if (label === "Estimated Date on Property" && field.value) {
              const date = new Date(parseInt(field.value));
              formattedValue = date.toLocaleDateString(); 
            }

            if (label === "Actual Delivery Date" && field.value) {
              const date = new Date(parseInt(field.value));
              formattedValue = date.toLocaleDateString(); 
              formattedActualDate = date.toLocaleDateString();
            }

            if (label === "Days Since Delivery" && field.value && formattedActualDate) {
              const today = new Date();

              const actualDate = new Date(formattedActualDate)

              const timeDifference = today - actualDate;

              const millisecondsInADay = 1000 * 60 * 60 * 24;
              const numberOfDays = Math.floor(timeDifference / millisecondsInADay);

              formattedValue = numberOfDays; 
            }

        const raw = (field.value || "").trim();
        const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    
            return (
              <Grid item xs={6} key={field.id}>
                <Typography variant="body2" style={{marginBottom:'10px'}}>
                  <strong>{label}:</strong>{" "}
                  {field.id === "e9ef5220-a08a-443d-bced-400eefd47cfc" ? (
                    field.value ? (
                      <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue", textDecoration: "none", overflowWrap: 'break-word' }}
                      >
                        {field.value}
                      </a>
                    ) : (
                      "N/A"
                    )
                  ) : (
                    formattedValue || "N/A"
                  )}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      );
    };

export default FieldsDetails;
